import axios from 'axios'

const baseUrl = process.env.REACT_APP_API_URL

// eslint-disable-next-line import/prefer-default-export
export async function deleteCustomsOfficeOfTransitExitV2(id: number): Promise<void> {
  await axios.delete<void>(`${baseUrl}/v2/customs-office/transit-exit/${id}`)
}
